import i18next from 'i18next';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { AuthState } from 'types';
import type { Slicers } from 'types/services';
import { getDeploymentTenantId } from 'utils/auth/tenantAccess';
import { getBaseUrl } from 'utils/baseUrl';
import { isMobileApp } from 'utils/common';

export const applyAuthHeaders = (headers: Headers, auth: AuthState) => {
  const mobileApp = isMobileApp();
  const { refreshToken, tokenProvider, jwtToken, apiKey } = auth;

  if (jwtToken && !headers.has('Authorization')) {
    headers.set('Authorization', jwtToken);
  }

  if (refreshToken) {
    headers.set('X-Refresh-Token', refreshToken);
  }

  if (tokenProvider) {
    // TODO: F20-3137 Stop sending X-Authorization-Provider after Google/Microsoft login cutover.
    headers.set('X-Authorization-Provider', tokenProvider);
  }

  headers.set('X-Mobile-Platform', '');
  headers.set('X-Device-Type', mobileApp ? 'Mobile' : 'Browser');
  headers.set('Accept-Language', i18next.language);
  headers.set('X-Api-Key', apiKey ?? '');

  return headers;
};

export const createBaseQuery = ({ extendedUrl }: { extendedUrl: string }) =>
  fetchBaseQuery({
    baseUrl: getBaseUrl(`/api/${extendedUrl}`),
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();

      for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) {
          continue;
        }
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v));
        } else {
          searchParams.append(key, value);
        }
      }

      return searchParams.toString();
    },
    prepareHeaders: async (headers, { getState }) => {
      const { auth } = getState() as Slicers;

      applyAuthHeaders(headers, auth);

      const tenantId = getDeploymentTenantId();

      if (tenantId) {
        headers.set('X-Tenant-Id', tenantId);
      }

      return headers;
    },
  });
